module.exports = __webpack_public_path__ + "media/images/sp/staffs/mv_hair_makeup-26b15a08fc096411e5bb57f646e982b7.webp";